import { render, staticRenderFns } from "./EditBrand.vue?vue&type=template&id=914ded70&scoped=true"
import script from "./EditBrand.vue?vue&type=script&lang=js"
export * from "./EditBrand.vue?vue&type=script&lang=js"
import style0 from "./EditBrand.vue?vue&type=style&index=0&id=914ded70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914ded70",
  null
  
)

export default component.exports